export const SOME_RIDICULOUS_NUMBER = 10000000000000;
